export default "__VITE_ASSET__BRKp7Gqu__"